<div #chatboxParent [class.embedded-container]="isEmbedded">
  <crchat-chatwidget *ngIf='channel' id='chatbox' [channel]='channel' version=''
                       [options]='optionsList' [mode]='widgetMode' [extensionService]='chatExtension'></crchat-chatwidget>
  <!--<crchat-chatwidget *ngIf='channel && dev' id='chatbox' [channel]='channel' version=''
                       options='{"isOpen":"true", "isPopup":"true", "isApp":"true", "loadHistory":"true", "autoStart":"true", "authRequired":"true", "allowScreenshot": "true", "env":"dev", "createNew":"true"}'></crchat-chatwidget>-->
</div>
